﻿shvenergy.tariff = (function ($) {
	"use strict";

    function init() {

	//details popup
		$(document).on("click", ".details-button", function (e) {
            e.stopPropagation();


            const id = $(this).data("tariffbodyitemid");
			const clonedContent = $("#" + id).clone(true);

			clonedContent.css({
				'display': 'block'
			});

            var extraClass = clonedContent.hasClass("tariff-modal-html--best-value") ? "tariff-modal tariff-modal--best-value" : "tariff-modal";
		    extraClass += clonedContent.hasClass("tariff-modal--bio") ? " tariff-modal--bio" : "";

			shvenergy.modal.showModal(clonedContent.html(), {
				extraClass: extraClass,
				extraBackdropClass: "",
				focusElement: ""
				//moveCloseButtonTo: ".tariff-modal-header"
			});

			shvenergy.tracking.trackEvent("QuoteTool", "Show details clicked", $(this).data("name"));

		});
	}

    init();

})(jQuery);